import { t } from "@dovach/i18n";

export function TrustFooter() {
  return (
    <footer className="mt-8 border-t border-slate-200 pt-4 text-sm text-slate-500 dark:border-slate-800 dark:text-slate-400">
      <p>{t("client_web.trust_footer_note")}</p>
      <p className="mt-2">
        Dovach ·{" "}
        <a className="underline hover:text-brand-700" href="https://dovach.com/help">
          {t("client_web.about_link")}
        </a>
      </p>
    </footer>
  );
}
